import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import axios from "axios";

export const Search = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState("");

  const inputRef = useRef(null);

  function showSearchBar() {
    if (!isVisible) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
      setData("");
    }
  }

  function resultsToolTips(e) {
    if (e.target.value) {
      getResults(e.target.value);
    } else {
      setData("");
    }
  }

  async function getResults(term) {
    try {
      const response = await axios.get(`${pol.root_url}/wp-json/api/v1/search?term=${term}`);
      setData(response.data);
    } catch (error) {
      setData(error);
      console.error(error);
    }
  }

  useEffect(() => {
    if (inputRef) {
      if (inputRef.current !== null) {
        inputRef.current.focus();
      }
    }
  });

  return (
    <>
      <svg
        width="1.2rem"
        height="1.2rem"
        viewBox="0 0 16 16"
        className="bi bi-search text-light ml-3"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        onClick={showSearchBar}
      >
        <path
          fillRule="evenodd"
          d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"
        />
        <path
          fillRule="evenodd"
          d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
        />
      </svg>

      {isVisible && (
        <form
          action={pol.root_url}
          method="GET"
          className="mt-small"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
        >
          <input
            name="s"
            id="search"
            type="search"
            placeholder="Căutare"
            className="form-control border-indigo"
            aria-describedby="Căutare"
            onChange={resultsToolTips}
            ref={inputRef}
          />
        </form>
      )}
    </>
  );
};

ReactDOM.render(<Search />, document.getElementById("search-icon"));
